module.exports = __webpack_public_path__ + "assets/img/granngarden-logo.3c7070ff.png";